import { isFormatType } from '../../../types/transformations';
export const mapFormatTransformation = ({ format }) => {
    if (!format) {
        return undefined;
    }
    if (!isFormatType(format)) {
        return undefined;
    }
    return format;
};
const mapperQualityValues = new Map([
    ['auto', 'low'],
    ['low', 'low'],
    ['medium', 'low'],
    ['high', 'high'],
]);
export const mapQualityTransformation = ({ quality }) => {
    if (!quality) {
        return undefined;
    }
    const qualityDh = mapperQualityValues.get(quality);
    if (!qualityDh) {
        return undefined;
    }
    return { q: qualityDh };
};
export const mapQualityFormatTransformation = (transformation) => {
    const qualityDh = mapQualityTransformation(transformation);
    const formatDh = mapFormatTransformation(transformation);
    if (!qualityDh) {
        return formatDh ? { [formatDh]: {} } : undefined;
    }
    if (!formatDh) {
        return { auto: qualityDh };
    }
    return { [formatDh]: qualityDh };
};
//# sourceMappingURL=quality-format.js.map